export const NAVBAR_OPENED = 'isNavbarOpened'
export const IS_DISRUPTION_MESSAGE_VISIBLE = 'isDisruptionMessageVisible'
